import { Theme } from '../types';

export const oceanTheme: Theme = {
  name: 'ocean',
  colors: {
    gray: {
      50: '#f0f9ff',
      100: '#e0f2fe',
      200: '#bae6fd',
      300: '#7dd3fc',
      400: '#38bdf8',
      500: '#0ea5e9',
      600: '#0284c7',
      700: '#0369a1',
      800: '#075985',
      900: '#0c4a6e',
    },
    accent: {
      50: '#ecfdf5',
      100: '#d1fae5',
      200: '#a7f3d0',
      300: '#6ee7b7',
      400: '#34d399',
      500: '#10b981',
      600: '#059669',
      700: '#047857',
      800: '#065f46',
      900: '#064e3b',
    },
    semantic: {
      success: '#10b981',
      successLight: '#d1fae5',
      error: '#ef4444',
      errorLight: '#fee2e2',
      warning: '#f59e0b',
      warningLight: '#fef3c7',
      info: '#0ea5e9',
      infoLight: '#e0f2fe',
    },
    background: {
      app: '#f0f9ff',
      surface: '#ffffff',
      elevated: '#ffffff',
      navbar: '#ffffff',
      sidebar: '#e0f2fe',
      hover: '#e0f2fe',
      active: '#bae6fd',
      blueprint: 'linear-gradient(135deg, #f0f9ff 0%, #bae6fd 100%)',
    },
    text: {
      primary: '#0c4a6e',
      secondary: '#075985',
      tertiary: '#0369a1',
      disabled: '#7dd3fc',
      inverse: '#ffffff',
      accent: '#059669',
      onAccent: '#ffffff',
      muted: '#0284c7',
    },
    border: {
      color: '#bae6fd',
      light: '#e0f2fe',
      medium: '#7dd3fc',
    },
    button: {
      bg: '#f0f9ff',
      bgHover: '#e0f2fe',
      bgActive: '#bae6fd',
      text: '#0369a1',
      border: '#7dd3fc',
      primary: {
        bg: '#0ea5e9',
        bgHover: '#0284c7',
        bgActive: '#0369a1',
        text: '#ffffff',
      },
      disabled: {
        bg: '#e0f2fe',
        text: '#7dd3fc',
        border: '#bae6fd',
      },
    },
    input: {
      bg: '#ffffff',
      border: '#7dd3fc',
      borderHover: '#38bdf8',
      borderFocus: '#0ea5e9',
      text: '#0c4a6e',
      placeholder: '#7dd3fc',
    },
    toggle: {
      bg: '#7dd3fc',
      bgActive: '#0ea5e9',
      thumb: '#ffffff',
    },
    executing: '#f59e0b',
    focus: '#0ea5e9',
    overlay: {
      light: 'rgba(12, 74, 110, 0.1)',
      medium: 'rgba(12, 74, 110, 0.2)',
      heavy: 'rgba(12, 74, 110, 0.3)',
      white: 'rgba(255, 255, 255, 0.1)',
    },
    shadow: {
      medium: 'rgba(14, 165, 233, 0.15)',
    },
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    // Legacy spacing
    small: '8px',
    medium: '16px',
    large: '24px',
  },
  typography: {
    fontFamily: "'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: {
      xs: '12px',
      sm: '14px',
      base: '16px',
      lg: '18px',
      xl: '20px',
      xxl: '24px',
      xxxl: '30px',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    text: {
      xs: '12px',
      small: '14px',
      medium: '16px',
    },
  },
  borderRadius: {
    sm: '6px',
    md: '10px',
    lg: '16px',
    full: '9999px',
    // Legacy border radius
    small: '3px',
    medium: '8px',
  },
  shadows: {
    xs: '0 1px 2px 0 rgba(14, 165, 233, 0.05)',
    sm: '0 1px 3px 0 rgba(14, 165, 233, 0.08), 0 1px 2px -1px rgba(14, 165, 233, 0.08)',
    md: '0 4px 6px -1px rgba(14, 165, 233, 0.08), 0 2px 4px -2px rgba(14, 165, 233, 0.08)',
    lg: '0 10px 15px -3px rgba(14, 165, 233, 0.08), 0 4px 6px -4px rgba(14, 165, 233, 0.08)',
    xl: '0 20px 25px -5px rgba(14, 165, 233, 0.08), 0 8px 10px -6px rgba(14, 165, 233, 0.08)',
  },
  zIndex: {
    dropdown: 100,
    sticky: 200,
    overlay: 500,
    modal: 1000,
    toast: 2000,
    // Legacy z-index
    base: 0,
    accent: 5,
    content: 10,
    floating: 20,
  },
  transitions: {
    fast: '150ms cubic-bezier(0.4, 0, 0.2, 1)',
    base: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
    slow: '300ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
  breakpoints: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1536px',
  },
};


